import React, { useEffect, useRef } from "react";
import "./Main_Photo.css";
const buildingImage = require("./assets/images/buildings.jpg");
function Main_Photo() {
  const textRef = useRef(null);

  useEffect(() => {
    const node = textRef.current;
    if (!node) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          } else {
            entry.target.classList.remove("animate-in");
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% visible
    );

    observer.observe(node);

    return () => {
      observer.unobserve(node);
    };
  }, []);

  return (
    <div
      className="main-photo"
      style={{ backgroundImage: `url(${buildingImage})` }}
    >
      <div className="main-photo-container">
        <div className="black-bg">
          <div ref={textRef} className="main_imgtext">
            <span className="hero-line">
              <span className="hero-word">
                <span className="diffcolor">C</span>entre
              </span>{" "}
              <span className="hero-word">for</span>
            </span>{" "}
            <span className="hero-line">
              <span className="hero-word">
                <span className="diffcolor">I</span>nterdisciplinary
              </span>
            </span>{" "}
            <span className="hero-line">
              <span className="hero-word">
                <span className="diffcolor">P</span>rograms
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main_Photo;
